/*
 * @Author: edvardchen
 * @Date:   2016-10-26 11:57:31
 * @Last Modified by:   edvardchen
 * @Last Modified time: 2016-10-26 11:58:13
 */

export const THUMBNAIL = 0;
export const FOCUS = 1;
